import { defaultPeriodValue } from '@/react/edge/edge-stacks/components/RetryDeployPeriod';
import { getDefaultStaggerConfig } from '@/react/edge/edge-stacks/components/StaggerFieldset.types';
import { getDefaultRelativePathModel } from '@/react/portainer/gitops/RelativePathFieldset/types';

import { Artifact } from './types';
import { DeploymentType } from './detectDeploymentType';

export function createEmptyArtifact(): Artifact {
  return {
    name: '',
    dependencies: [],
    deploymentType: DeploymentType.Kubernetes,
    files: [],
    targets: [],
    environmentGroups: [],
    environments: [],
    helm: { enabled: false, valuesFiles: [], namespace: '' },
    config: {
      envVars: [],
      prePullImage: false,
      retryDeploy: false,
      retryPeriod: defaultPeriodValue,
      parallelConfig: getDefaultStaggerConfig(),
      relativePath: getDefaultRelativePathModel(),
      useManifestNamespaces: false,
      // Pruning is on by default.
      kubernetesPrune: true,
      kubernetesForceApply: false,
      // Reporting drift changes nothing on the cluster, and a deployment that
      // silently stopped matching its source is what the engine exists to
      // surface. Correcting it stays an explicit choice.
      driftMode: 'warn',
    },
  };
}
